export enum AuthStatus {
  CONFIGURING = 'configuring',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
}
